"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Item = _interopRequireDefault(require("./Item"));
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/Menu/index.js";
function Menu(_ref) {
  var _this = this;
  var menus = _ref.menus,
    onClickItem = _ref.onClickItem;
  function renderDivider(index) {
    return /*#__PURE__*/_react["default"].createElement("hr", {
      key: index,
      className: "dropdown-divider bg-light",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 6,
        columnNumber: 17
      }
    });
  }
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: "navbar-nav",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10,
      columnNumber: 9
    }
  }, menus.map(function (menu, i) {
    if (!Object.keys(menu).length) return renderDivider(i);
    var key = menu.key || menu.route || 'menu-' + i;
    return /*#__PURE__*/_react["default"].createElement(_Item["default"], {
      key: key,
      menu: menu,
      onClick: onClickItem,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 18,
        columnNumber: 28
      }
    });
  }));
}
var _default = Menu;
exports["default"] = _default;